module.exports = __webpack_public_path__ + "static/media/headLogo.72d66efa.svg";